module.exports = __webpack_public_path__ + "static/media/linechart.1edf6cec.svg";